// extracted by css-extract-rspack-plugin
export default {"i3fdetails":"i3fdetails-2VE2Q"};